<template>
    <div>
        <breadcrumbs class="pb-3" :text="vehicleTypeForm?.useVehicleName" />
        <v-tabs v-model="productTab" color="primary">
            <v-tab value="information">{{ $t('information') }}</v-tab>
            <v-tab v-if="useIsShowTransferSeats" value="seat-map">
                {{ $t('seat_map') }}
            </v-tab>
        </v-tabs>
        <v-tabs-window v-model="productTab">
            <v-tabs-window-item value="information" class="pt-4">
                <v-row dense class="mb-5">
                    <v-col cols="12" md="5">
                        <VehicleTypeForm ref="vehicleTypeForm" :edit-vehicle-type-id="vehicleTypeId" />
                    </v-col>
                </v-row>
            </v-tabs-window-item>
            <v-tabs-window-item value="seat-map" class="pt-4">
                <v-row dense class="mb-5">
                    <v-col cols="12" md="5">
                        <SeatMapForm
                            :linked-object-id="vehicleTypeId"
                            :max-capacity="vehicleTypeForm?.useVehicleMaxCapacity"
                            seat-type="VEHICLE"
                            @cancel="$router.push({name: 'vehicleTypes'})"
                        />
                    </v-col>
                </v-row>
            </v-tabs-window-item>
        </v-tabs-window>
    </div>
</template>
<script setup lang="ts">
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import VehicleTypeForm from '~/components/account/vehicleTypes/VehicleTypeForm.vue'
    import SeatMapForm from '~/components/account/seatMap/SeatMapForm.vue'

    const productTab = ref<string>()
    const vehicleTypeForm = ref(null)
    const vehicleTypeId = ref(null)

    onMounted(async () => {
        const {params} = useRoute()
        vehicleTypeId.value = params?.id
        productTab.value = 'information'
    })

    const useIsShowTransferSeats = computed(() => {
        return (
            runtimeStore.getCRMOption('asp.option.ownTransfers.show.seats') ||
            runtimeStore.getCRMOption('asp.option.ownExcursions.show.seats') ||
            false
        )
    })
</script>
